import axios from "axios";
import Base64 from "src/libraries/utils/base64";
import { APP_CONFIGS } from "../configs/app-configs";
import EventBus, { EventBusType, EventBusName } from "../eventbus/event-bus";
import { StorageKey } from "../storage/local-storage-helpers";
import localStorageHelpers from "../storage/local-storage-helpers";

const OAuth2Helper = (() => {
  let instance: any;
  let accessToken: string;
  let refreshToken: string;

  const getAccessToken = async () => {
    console.log("OAUTH2: getting token");
    if (accessToken) {
      return accessToken;
    }

    console.log("OAUTH2: getting token from storage");
    let accessTokenFromStorage = await localStorageHelpers.get(
      StorageKey.ACCESS_TOKEN
    );
    if (accessTokenFromStorage) {
      setAccessToken(accessTokenFromStorage);
      return accessTokenFromStorage;
    }

    return null;
  };

  const setAccessToken = async (value: string) => {
    accessToken = value;
    await localStorageHelpers.remove(StorageKey.ACCESS_TOKEN);
    await localStorageHelpers.save(StorageKey.ACCESS_TOKEN, value);
  };

  const setRefreshToken = async (value: string) => {
    refreshToken = value;
    await localStorageHelpers.remove(StorageKey.REFRESH_TOKEN);
    await localStorageHelpers.save(StorageKey.REFRESH_TOKEN, value);
  };

  const getRefreshToken = async () => {
    console.log("OAUTH2: getting refresh token");
    if (refreshToken) {
      return refreshToken;
    }

    console.log("OAUTH2: getting refresh token from storage");
    let refreshTokenFromStorage = await localStorageHelpers.get(
      StorageKey.REFRESH_TOKEN
    );

    if (refreshTokenFromStorage) {
      setRefreshToken(refreshTokenFromStorage);
      return refreshTokenFromStorage;
    }

    return "";
  };

  function init() {
    let fetching: boolean = false;
    return {
      getAccessToken: async (refreshForced: boolean) => {
        let accessToken = await getAccessToken();
        console.log("OAUTH2: GETTING", accessToken);
        let refreshToken = await getRefreshToken();

        //if (accessToken != null && !isExpiredToken(accessToken) && !refreshForced) {
        if (accessToken != null && !refreshForced) {
          return accessToken;
        }
        if (fetching) {
          return new Promise((resolve) => {
            EventBus.getInstance().events.subscribe((res: EventBusType) => {
              if (res?.type === EventBusName.RENEW_TOKEN) {
                resolve(accessToken);
              }
            });
          });
        } else {
          if (refreshToken) {
            await reauthorizeByRefreshToken();
            let accessResult = getAccessToken();
            console.log("OAuth2 - 3:", accessResult);

            return accessResult;
          }
        }

        EventBus.getInstance().post({
          type: EventBusName.EXPIRE_TOKEN,
          payload: "refresh token",
        });
      },
    };

    function isExpiredToken(accessToken: string) {
      let decodeInfo = decodeJwt(accessToken);
      if (decodeInfo) {
        let now = new Date();
        const exp = decodeInfo.exp ?? null;
        const status = now.getTime() - exp * 1000 > 0;

        if (exp) {
          return status;
        }
      }
      return true;
    }

    function decodeJwt(accessToken: string) {
      try {
        let base64Url = accessToken.split(".")[1];
        let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        let jsonPayload = decodeURIComponent(
          Base64.atob(base64)
            .split("")
            .map(function (c) {
              return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join("")
        );

        return JSON.parse(jsonPayload);
      } catch (error) {
        return null;
      }
    }

    async function reauthorizeByRefreshToken() {
      fetching = true;
      let data = new URLSearchParams();
      data.append("refresh_token", await getRefreshToken());
      data.append("client_id", "web");
      data.append("grant_type", "refresh_token");

      try {
        const response = await axios({
          method: "POST",
          url: APP_CONFIGS.GET_TOKEN_SERVER,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          data: data,
          timeout: 30000,
        });

        await removeAuthenticateInfo();
        await replaceAuthenticateInfo(
          response?.data?.access_token,
          response?.data?.refresh_token
        );

        EventBus.getInstance().post({
          type: EventBusName.RENEW_TOKEN,
        });
        fetching = false;
      } catch (error) {
        await localStorageHelpers.remove(StorageKey.ACCESS_TOKEN);

        await localStorageHelpers.remove(StorageKey.REFRESH_TOKEN);
        console.log("ERROR TOKEN ", error);

        EventBus.getInstance().post({
          type: EventBusName.REDIRECT_SSO,
        });
      }
    }

    async function removeAuthenticateInfo() {
      await localStorageHelpers.remove(StorageKey.ACCESS_TOKEN);
      await localStorageHelpers.remove(StorageKey.REFRESH_TOKEN);
      await localStorageHelpers.remove(StorageKey.USER_INFO);
    }

    async function replaceAuthenticateInfo(
      accessToken: string,
      refreshToken: string
    ) {
      setAccessToken(accessToken);
      setRefreshToken(refreshToken);

      let profile: any = Base64.atob(
        accessToken.split(".")[1]?.replace(/-/g, "+")?.replace(/_/g, "/")
      );
      await localStorageHelpers.save(StorageKey.USER_INFO, profile);
      console.log("SEND UPDATE USER REQUEST");
      EventBus.getInstance().post({
        type: EventBusName.UPDATE_USER_INFO,
      });
    }
  }
  return {
    getInstance: () => {
      if (!instance) instance = init();

      return instance;
    },
    renewInstance: () => {
      instance = null;
      accessToken = "";
      refreshToken = "";
    },
  };
})();

export default OAuth2Helper;
